export const initialAbility = [
  {
    action: 'read',
    subject: 'app',
  },
]

export const _ = undefined
